<template>
<div class="mt-2 px-2 mx-auto rounded d-flex align-items-center" style="width:96%;background-color: white;border:1px solid #dee2e6 !important">
    <ul class="w3_short dir-rtl fl-right mb-0 pr-0">
        <li>
            <router-link :to="{name:'Home'}">خانه</router-link>
            <fa class="fa fa-chevron-left px-2"></fa>
        </li>
        <li v-for="item,index in vector" :key="index">
            <router-link :to="item.path">{{item.fa}}</router-link>
            <fa class="fa fa-chevron-left px-2" v-if="index != vector.length-1"></fa>
        </li>
    </ul>
</div>
</template>
    
<script setup>
// import axios from 'axios'
import { defineProps,computed,watch} from 'vue'
import { useRoute} from 'vue-router'
const props = defineProps(['vector']) 
let route = useRoute()
const page = computed(() => props.vector);
watch(page, async () => {
    const vector = props.vector
}, { immediate: true });

</script>
<style scoped>
li{
    font-weight:900;
    color:#6c757d;
}
i{
    font-size: smaller;
    color: rgb(108, 117, 125);
}
.router-link-active {
    color: #364d71 !important;
}
</style>